import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const PesoButoTrotalFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='PESO BRUTO TOTAL' htmlFor='input-pesoBrutoTotal' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='pesoBrutoTotal'>
          {({ field }) => <Form.InputNumber {...field} disabled={fIsSubmitting} isInvalid={iTouched && iError} id='input-pesoBrutoTotal' />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(PesoButoTrotalFormGroup)
